/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { url } from 'utils/urls';
// unique elements
import Frame from 'components/frames/frame_container';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import CTAs from 'components/shared/ctas/ctas';
import Button from 'components/shared/button/button';
import InsticatorLogo from 'components/shared/logo/insticator/insticator_container';
// utils
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// import Close from 'components/shared/close/close';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/optin/optin_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
import { isLocalStorageExists } from 'utils/environment';
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ OPTIN SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class OptinScreen extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // trackEvent('load', 'screenLoaded', this.props, {type: 'privacy_optin'});
    }
    handleUserAgrees = (e) => {
        refreshAds();
        this.props.processUsersConsent();
    };
    createMarkup() {
        return (
            <div className={`optin`}>
                <div className={`dimmer`} />
                <div className={`group`}>
                    <BodyCopy>
                        <InsticatorLogo contentId={null} poweredBy={true} />
                        <p>Insticator uses cookies. By clicking “I agree”, you consent to our use of cookies and agree to our <a href={`${url.company}/terms`} target={`blank`}>Terms and Conditions</a>, <a href={`${url.company}/cookies`} target={`blank`}> Cookie Policy </a> and <a href={`${url.company}/privacy`} target={`blank`}>Privacy Policy.</a></p>
                    </BodyCopy>
                    <CTAs type={`inline`}>
                        <Button klass={`white`} onClick={this.handleUserAgrees}>{`I agree`}</Button>
                    </CTAs>
                </div>
            </div>
        );
    }
    render() {
        return(
            <div className={`${sheet.classes.uniquecontent} uniquecontent inview-${this.props.inView}`}>
                {/*<Close handleClick={this.handleClose} />*/}
                {this.createMarkup()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default OptinScreen;
